import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { FlyoutModel } from '../../models/flyout.model';

// identifier
export const FLYOUT_SLICE_ID = 'flyouts';

// default state
const initialState: FlyoutModel = {
  flyoutVisible: false,
  flyoutId: null,
  flyoutParameters: {},
};

//slice
const flyoutSlice = createSlice({
  name: FLYOUT_SLICE_ID,
  initialState,
  reducers: {
    toggleFlyout: (state: FlyoutModel, action: PayloadAction<boolean>) => {
      if (!action.payload) {
        state.flyoutVisible = false;
        state.flyoutId = null;
        state.flyoutParameters = {};
      } else {
        state.flyoutVisible = action.payload;
      }
    },
    setFlyoutTemplate: (state: FlyoutModel, action: PayloadAction<Partial<FlyoutModel>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

//selectors

export const selectIsFlyoutVisbile = (state: RootState) => state.flyouts.flyoutVisible;

export const selectFlyoutData = (state: RootState) => state.flyouts.flyoutParameters;

export const selectFlyoutTemplate = (state: RootState) => state.flyouts.flyoutId;

//actions
export const { toggleFlyout, setFlyoutTemplate } = flyoutSlice.actions;

//reducer
export default flyoutSlice;
